import React from 'react';
import './styles/report-layout.scss';

interface ReportLayoutProps {
  readonly header: React.ReactNode;
  readonly utility?: React.ReactNode;
  readonly filters?: React.ReactNode;
  readonly notices?: React.ReactNode;
  readonly children: React.ReactNode;
}

/** Screen geometry for live P&L reports. */
export const ReportLayout: React.FC<ReportLayoutProps> = ({ header, utility, filters, notices, children }) => (
  <div className="sg-report-layout">
    <header className="sg-report-layout-heading">{header}</header>
    {utility && <div className="sg-report-layout-utility">{utility}</div>}
    {filters && <div className="sg-report-layout-filters">{filters}</div>}
    {notices && <div className="sg-report-layout-notices">{notices}</div>}
    <div className="sg-report-layout-content">{children}</div>
  </div>
);
